import { AlertTriangle, CheckCircle2, RefreshCw, Server } from "lucide-react";


export const FingerproxyGlobalStatusHeader = ({ diagnostics, syncResult, syncing, onSync }) => {
  const results = syncResult?.results || diagnostics?.results || [];
  const failed = results.filter((item) => !item.success);
  const healthy = results.length - failed.length;
  const success = results.length > 0 && failed.length === 0;

  return (
    <section className={`border p-4 rounded-lg ${success ? "border-emerald-800/60 bg-emerald-950/30" : "border-amber-800/60 bg-amber-950/30"}`} data-testid="fingerproxy-sync-banner">
      <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            {success ? <CheckCircle2 className="h-5 w-5 text-emerald-400" /> : <AlertTriangle className="h-5 w-5 text-amber-400" />}
            <h2 className="text-base font-semibold text-slate-100" data-testid="fingerproxy-sync-summary">
              {results.length ? `${healthy}/${results.length} Fingerproxy agents ready` : "Checking Fingerproxy agents"}
            </h2>
          </div>
          {failed.length > 0 && (
            <div className="mt-3 flex flex-wrap gap-2" data-testid="fingerproxy-failing-agents">
              {failed.map((agent) => (
                <div key={agent.server_id || agent.ip_address} className="max-w-full border border-rose-500/25 bg-rose-500/10 px-3 py-2 rounded-md" data-testid={`failing-agent-${agent.server_id || "unknown"}`}>
                  <p className="flex items-center gap-2 text-xs font-semibold text-rose-300">
                    <Server className="h-3.5 w-3.5" />
                    {agent.server_name || agent.ip_address || "Unknown agent"}
                  </p>
                  <p className="mt-1 break-words text-xs text-slate-300" data-testid={`failing-agent-error-${agent.server_id || "unknown"}`}>
                    {agent.error || agent.output || "Sync failed without diagnostic output"}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
        <button type="button" onClick={onSync} disabled={syncing} className="btn-primary flex shrink-0 items-center justify-center gap-2 disabled:opacity-50" data-testid="fingerproxy-resync-all-button">
          <RefreshCw className={`h-4 w-4 ${syncing ? "animate-spin" : ""}`} />
          {syncing ? "Syncing agents..." : "Re-sync all agents"}
        </button>
      </div>
    </section>
  );
};